import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// eslint-disable-next-line prettier/prettier
import type { CommentPayloadType } from '@/api/types/request/CommentPayloadType'
import type { CommentType } from '@/api/types/response/CommentType'

/**
 * @property string apiEnd /api/sales/comments/{bidNumber}
 */
export default class CommentApi extends AbstractApi {
  add(payload: CommentPayloadType): Promise<CommentType> {
    return httpClient.post(this.apiEnd, payload)
  }

  update(id: number, payload: CommentPayloadType): Promise<CommentType> {
    return httpClient.put(`${this.apiEnd}/${id}`, payload)
  }

  delete(id: number): Promise<CommentType> {
    return httpClient.delete(`${this.apiEnd}/${id}`)
  }
}
